import React from "react";

import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import BusinessCenterIcon from "@mui/icons-material/BusinessCenter";

import { Link } from "react-scroll";
import { styled } from "@mui/system";

const CustomLink = styled(Link)(({ theme }) => ({
  color: theme.palette.primary.h300,
  textShadow: "2px 2px 4px rgba(0, 0, 0, 0.5)",
  transition: "color 0.3s", // Optional: Add a smooth transition effect
  "&:hover": {
    color: theme.palette.primary.h400,
  },
}));

const Navbar = () => {
  const CustomBox = styled(Box)(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "1rem",
    [theme.breakpoints.down("sm")]: {
      marginTop: "2rem",
    },
  }));

  const CustomToolbar = styled(Box)(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
    },
  }));

  return (
    <Box sx={{ flexGrow: 1, px: 5, py: 2, maxWidth: "1200px", mx: "auto" }}>
      <AppBar
        position="static"
        style={{ background: "transparent", boxShadow: "none" }}
      >
        <CustomToolbar>
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              gap: "1rem",
            }}
          >
            <Typography
              sx={{
                flexGrow: 1,
                fontSize: "18px",
                fontWeight: "00",
                // textShadow: "2px 2px 4px rgba(0, 0, 0, 0.5)",
                color: "#C68084",
              }}
            >
              Emelie Köhler's
            </Typography>
            <Link to="projects" className="link" smooth>
              <BusinessCenterIcon />
            </Link>
          </Box>

          <CustomBox>
            <CustomLink to="projects" className="link" smooth>
              PROJEKT
            </CustomLink>
            <CustomLink to="skills" className="link" smooth>
              SKILLS
            </CustomLink>
            <CustomLink to="about" className="link" smooth>
              OM MIG
            </CustomLink>
          </CustomBox>
        </CustomToolbar>
      </AppBar>
    </Box>
  );
};

export default Navbar;
